module.exports = __webpack_public_path__ + "img/logo_v3_white.5cd695b8.svg";